import api from './api';

console.log('[ORDER SERVICE] orderService.js loaded');

export const fetchOrdersForAutoEvaluation = async () => {
  console.log('[ORDER SERVICE] fetchOrdersForAutoEvaluation() called...');
  try {
    const response = await api.get('/orders/auto-evaluation');
    
    console.log('[ORDER SERVICE] Raw Axios Response:', response);
    console.log('[ORDER SERVICE] Response Status:', response.status);
    console.log('[ORDER SERVICE] Response Headers:', response.headers);

    const orders = response.data;
    console.log('[ORDER SERVICE] Parsed Orders from response.data:', orders);

    if (!Array.isArray(orders)) {
      console.warn('[ORDER SERVICE] ⚠️ Response data is not an array. Actual content:', orders);
    }

    return orders;
  } catch (error) {
    console.error('[ORDER SERVICE] fetchOrdersForAutoEvaluation() - Error:', error.response?.data || error.message);
    throw error;
  }
};


// ✅ Fetch orders for Manual Evaluation (calls /orders/manual-evaluation)
export const fetchOrdersForManualEvaluation = async () => {
  console.log('[ORDER SERVICE] fetchOrdersForManualEvaluation() called...');
  try {
    const response = await api.get('/orders/manual-evaluation');
    const orders = response.data;
    console.log('[ORDER SERVICE] Orders received (Manual Evaluation):', orders);
    return orders;
  } catch (error) {
    console.error('[ORDER SERVICE] fetchOrdersForManualEvaluation() - Error:', error.response?.data || error.message);
    throw error;
  }
};

// ✅ Fetch single order by ID
export const fetchOrderById = async (id) => {
  console.log(`[ORDER SERVICE] fetchOrderById(${id}) called - Starting to fetch order...`);
  try {
    const response = await api.get(`/orders/${id}`);
    console.log(`[ORDER SERVICE] fetchOrderById(${id}) - Response received:`, response);
    console.log(`[ORDER SERVICE] fetchOrderById(${id}) - Data:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`[ORDER SERVICE] fetchOrderById(${id}) - Error occurred:`, error.response?.data || error.message);
    throw error;
  }
};


// ✅ Update order by ID (used in approval step)
export const updateOrder = async (id, updates) => {
  console.log(`[ORDER SERVICE] updateOrder(${id}) called - Starting update...`);
  console.log(`[ORDER SERVICE] updateOrder(${id}) - Updates to apply:`, updates);
  try {
    const response = await api.put(`/orders/${id}`, updates);
    console.log(`[ORDER SERVICE] updateOrder(${id}) - Response received:`, response);
    console.log(`[ORDER SERVICE] updateOrder(${id}) - Updated Data:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`[ORDER SERVICE] updateOrder(${id}) - Error occurred:`, error.response?.data || error.message);
    throw error;
  }
};




// ✅ Fetch all orders ready for approval (auto + manual evaluated)
export const fetchOrdersForApproval = async () => {
  console.log('[ORDER SERVICE] fetchOrdersForApproval() called - Requesting evaluated orders...');
  
  try {
    const response = await api.get('/orders/ready-for-approval');
    console.log('[ORDER SERVICE] fetchOrdersForApproval() - Response received:', response);
    return response.data;
  } catch (error) {
    console.error('[ORDER SERVICE] fetchOrdersForApproval() - Error occurred:', error.response?.data || error.message);
    throw error;
  }
};



// API call to update the score. 
export const editOrderScore = async (orderId, updatedScores) => {
  try {
    const response = await axios.put(`/api/orders/${orderId}/edit-score`, updatedScores);
    return response.data; // assuming response has a success field or status
  } catch (error) {
    console.error('Error while updating order score:', error);
    throw error; // This will be caught in the frontend
  }
};
